import React from "react";
import "./../styles/variable-projects.css";
import Projectsvariable from "../components/variable-projects";
import imagem1 from '../assets/images/Projetos/Banco Central do Brasil/banco.jpg';
import imagem2 from '../assets/images/Projetos/Banco Central do Brasil/banco2.jpg';
import imagem3 from '../assets/images/Projetos/Banco Central do Brasil/banco3.jpg';

const App = () => {
  const projectData = {
    date: "26/03/2018",
    title: "Banco Central do Brasil",
    images: [
     imagem1,
     imagem2,
     imagem3
    ],
    description:
    "Para projetos ligados BACEN – Banco Central do Brasil, atuamos com as soluções abaixo:",
    solutions: ["Cabeamento de Rede"],
  };

  return <Projectsvariable {...projectData} />;
};

export default App;